<isp-form-collapse
  [name]="props.name"
  [title]="(props.pageTitle$ | async).title"
  [opened]="props.opened"
  [icon]="props.icon"
  [inSprite]="props.inSprite"
  [titleFontSize]="(props.pageTitle$ | async).fontSize"
  [collapseTooltipMsg]="props.collapseTooltipMsg"
  [expandTooltipMsg]="props.expandTooltipMsg"
  [collapsible]="props.collapsible"
  [displayBackground]="props.displayBackground"
  [displayHeaderBackground]="props.displayHeaderBackground"
  (toggle)="emitPageCollapseEvent($event)"
>
  <ng-container #fieldComponent></ng-container>
</isp-form-collapse>
